export default "__VITE_ASSET__26f8fe30__"